export default __webpack_public_path__ + "static/media/advanced2.76e2b7bd.png";